import { render, staticRenderFns } from "./MessengerContactsGroup.vue?vue&type=template&id=46160b4d&scoped=true&"
import script from "./MessengerContactsGroup.vue?vue&type=script&lang=js&"
export * from "./MessengerContactsGroup.vue?vue&type=script&lang=js&"
import style0 from "./MessengerContactsGroup.vue?vue&type=style&index=0&id=46160b4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46160b4d",
  null
  
)

export default component.exports